import React, { useEffect, useState } from "react";
import { IBusDetail, ISeatDetail, ITripDetail } from "../../../../models/trip";
import LayoutSeatItem from "./LayoutSeatItem";
import { Button, Dropdown } from "antd";
import {
  CaretDownOutlined,
  DeleteOutlined,
  DownCircleOutlined,
  MoreOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";
import { ConfirmPopup, ErrorPopup } from "../../../../utilities/swal";
import { deleteBusApi } from "../../../../apis/bus.api";
import { MenuProps } from "antd/lib";
import ButtonRemoveBus from "../button/ButtonRemoveBus";
import ButtonRenameBus from "../button/ButtonChangeBusNumber";
import ButtonAddExtraSeat from "../button/ButtonAddExtraSeat";

interface BusItemProps {
  trip: ITripDetail;
  bus: IBusDetail;
  onSetTrip: React.Dispatch<React.SetStateAction<ITripDetail | null>>;
  handleSeatClick: (seat: ISeatDetail) => void;
  selectMode: string | null;
  targetCustomer: string | null;
  selectedSeats: ISeatDetail[];
  setBusIdChanged: React.Dispatch<React.SetStateAction<string[]>>;
  busIdChanged: string[];
  isFirstBus: boolean;
}

const BusItem: React.FC<BusItemProps> = (props: BusItemProps) => {
  const {
    bus,
    trip,
    onSetTrip,
    handleSeatClick,
    selectMode,
    selectedSeats,
    targetCustomer,
    busIdChanged,
    setBusIdChanged,
  } = props;
  const [isShowSeats, setIsShowSeats] = useState(props?.isFirstBus);
  const countSeats = (seats: ISeatDetail[]) => {
    // Nếu dữ liệu không hợp lệ → trả undefined
    if (!seats || !Array.isArray(seats)) return undefined;

    let available = 0;
    let booked = 0;

    seats.forEach((seat) => {
      if (seat?.status === "available") available++;
      if (seat?.status === "booked") booked++;
    });

    return { available, booked };
  };
  const items: MenuProps["items"] = [
   
    {
      key: "2",
      label: <ButtonRenameBus bus={bus} onSetTrip={onSetTrip} />,
    },
    {
      key: "1",
      label: <ButtonAddExtraSeat bus={bus} onSetTrip={onSetTrip} />,
    }, {
      key: "3",
      label: <ButtonRemoveBus bus={bus} onSetTrip={onSetTrip} />,
    },
  ];
  return (
    <div
      className={`w-full mt-2 rounded-xl shadow-md p-1 bg-white ${
        trip?.status === "hidden" ? "pointer-events-none opacity-50" : ""
      }`}
    >
      <div className="flex items-center justify-between gap-4 p-1">
        <div
          className="flex justify-between w-full cursor-pointer"
          onClick={() => setIsShowSeats((s) => !s)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setIsShowSeats((s) => !s);
          }}
        >
          <div className="flex items-center flex-col">
            <p className="text-lg font-semibold">Xe {bus?.busNumber}</p>
            <p className="text-sm text-gray-500">({bus?.busType} chỗ)</p>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-center">
              <p className="text-xl font-bold text-green-600">
                {countSeats(bus?.seats)
                  ? countSeats(bus?.seats)?.available
                  : bus?.availableSeats ?? 0}
              </p>
              <p className="text-sm text-gray-500">ghế trống</p>
            </div>
            <div className="text-center">
              <p className="text-xl font-bold text-red-600">
                {/* {countSeats(bus?.seats || [])?.booked ??
                  bus?.reservedSeats ??
                  0} */}
                {countSeats(bus?.seats)
                  ? countSeats(bus?.seats)?.booked
                  : bus?.reservedSeats ?? 0}
              </p>
              <p className="text-sm text-gray-500">ghế đặt</p>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <Button
            danger={!isShowSeats}
            onClick={() => setIsShowSeats(!isShowSeats)}
            icon={isShowSeats ? <UpCircleOutlined /> : <DownCircleOutlined />}
          ></Button>
          <Dropdown menu={{ items }}>
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        </div>
      </div>

      {isShowSeats && (
        <LayoutSeatItem
          handleSeatClick={(value) => handleSeatClick(value)}
          selectMode={selectMode}
          selectedSeats={selectedSeats}
          targetCustomer={targetCustomer}
          bus={bus}
          onSetTrip={onSetTrip}
          busIdChanged={busIdChanged}
          setBusIdChanged={setBusIdChanged}
        />
      )}
    </div>
  );
};

export default BusItem;
